import type { PublicProfile } from '@/types'
import { BeautyTemplate } from '@/components/templates/BeautyTemplate'
import { CreativeTemplate } from '@/components/templates/CreativeTemplate'
import { TradeTemplate } from '@/components/templates/TradeTemplate'
import { PhotographerTemplate } from '@/components/templates/PhotographerTemplate'
import { TattooArtistTemplate } from '@/components/templates/TattooArtistTemplate'
import { FloristTemplate } from '@/components/templates/FloristTemplate'
import { ArtistPainterTemplate } from '@/components/templates/ArtistPainterTemplate'
import { MakeupArtistTemplate } from '@/components/templates/MakeupArtistTemplate'
import { NailTechnicianTemplate } from '@/components/templates/NailTechnicianTemplate'
import { HairStylistTemplate } from '@/components/templates/HairStylistTemplate'
import { EstheticianTemplate } from '@/components/templates/EstheticianTemplate'
import { EventPlannerTemplate } from '@/components/templates/EventPlannerTemplate'
import { TutorTeacherTemplate } from '@/components/templates/TutorTeacherTemplate'
import { PersonalTrainerTemplate } from '@/components/templates/PersonalTrainerTemplate'
import { ElectricianTemplate } from '@/components/templates/ElectricianTemplate'
import { PlumberTemplate } from '@/components/templates/PlumberTemplate'
import { HVACTechnicianTemplate } from '@/components/templates/HVACTechnicianTemplate'
import { CarpenterTemplate } from '@/components/templates/CarpenterTemplate'

interface TemplatePreviewRendererProps {
  templateId: number
  profile: PublicProfile
}

export function TemplatePreviewRenderer({
  templateId,
  profile,
}: TemplatePreviewRendererProps) {
  switch (templateId) {
    case 1:
      return <BeautyTemplate profile={profile} />
    case 2:
      return <CreativeTemplate profile={profile} />
    case 3:
      return <TradeTemplate profile={profile} />
    case 4:
      return <PhotographerTemplate profile={profile} />
    case 5:
      return <TattooArtistTemplate profile={profile} />
    case 6:
      return <FloristTemplate profile={profile} />
    case 7:
      return <ArtistPainterTemplate profile={profile} />
    case 8:
      return <MakeupArtistTemplate profile={profile} />
    case 9:
      return <NailTechnicianTemplate profile={profile} />
    case 10:
      return <HairStylistTemplate profile={profile} />
    case 11:
      return <EstheticianTemplate profile={profile} />
    case 12:
      return <EventPlannerTemplate profile={profile} />
    case 13:
      return <TutorTeacherTemplate profile={profile} />
    case 14:
      return <PersonalTrainerTemplate profile={profile} />
    case 15:
      return <ElectricianTemplate profile={profile} />
    case 16:
      return <PlumberTemplate profile={profile} />
    case 17:
      return <HVACTechnicianTemplate profile={profile} />
    case 18:
      return <CarpenterTemplate profile={profile} />
    default:
      return <BeautyTemplate profile={profile} />
  }
}
